import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
// import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW1600Component } from './kymw1600.component';
import { ImageInfoDetailModule } from './image-info-detail/image-info-detail.module';
import { ImageInfoListModule } from './image-info-list/image-info-list.module';

import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageFileUrlService } from './api-services/get-image-file-url.service';
import { GetUseImageInfoService } from './api-services/get-use-image-info.service';
import { GetImageInfoDetailService } from './api-services/get-image-info-detail.service';
import { UpdateEnabledDeleteService } from './api-services/update-enabled-delete.service';
import { ReplaceImageFileUploadService } from './api-services/replace-image-file-upload.service';
import { ReplaceImageFileService } from './api-services/replace-image-file.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { KYMW1602Module } from '../kymw1602/kymw1602.module';


/**
 * 画像確認画面モジュール設定クラス
 *
 * @export KYMW1600Module
 * @class KYMW1600Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    ImageInfoDetailModule,
    ImageInfoListModule,
    KYMW1602Module,
  ],
  declarations: [
    KYMW1600Component,
  ],
  providers: [
    GetImageInfoService,
    GetImageFileUrlService,
    GetUseImageInfoService,
    GetImageInfoDetailService,
    UpdateEnabledDeleteService,
    ReplaceImageFileUploadService,
    ReplaceImageFileService,
    UpdateImageInfoService,
  ],
})
export class KYMW1600Module {

}
